<p-table
  #dt1
  [value]="users"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="false"
>
  <ng-template pTemplate="caption">
    <div [formGroup]="form" class="page-control flex align-items-start">
      <div class="grid w-100">
        <div
          class="col-12 flex justify-content-between mb-2 align-items-center"
        >
          <h2 class="text-black-alpha-90">Analiza - Zastoj</h2>

          <div class="flex">
            <button
              class="main-btn"
              [disabled]="!form.valid || data.length == 0"
              (click)="onExportPdf()"
              [ngClass]="{ disabled: !form.valid || data.length == 0 }"
            >
              Export PDF <i class="pi pi-file-pdf"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum od"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_from"
            ></p-calendar>
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_from')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum do"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_to"
            ></p-calendar>

            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_to')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-user>
    <tr *ngIf="users.length != 0">
      <th style="padding: 0.5rem">
        <span></span>
      </th>

      <th style="padding: 0.5rem">1 - Pauza/Ručak (min)</th>
      <th style="padding: 0.5rem">2 - Pomoć - Prijem robe (min)</th>
      <th style="padding: 0.5rem">3 - Pomoć - Utovar robe (min)</th>
      <th style="padding: 0.5rem">4 - Kvar - Mašina (Alat) (min)</th>
      <th style="padding: 0.5rem">5 - Nedostatak - Materijal (min)</th>
      <th style="padding: 0.5rem">6 - Nedostatak - TD (min)</th>
      <th style="padding: 0.5rem">7 - Sastanak (min)</th>
      <th style="padding: 0.5rem">8 - Obuka radnika (min)</th>
      <th style="padding: 0.5rem">9 - Ostalo (min)</th>

    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-user>
    <tr>
      <td>
        <span>{{ user?.username }}</span>
      </td>

      <td>
        <span>{{ user?.lunch_break }}</span>
      </td>

      <td>
        <span>{{ user?.help_delivery_package }}</span>
      </td>

      <td>
        <span>{{ user?.help_reciving_package }}</span>
      </td>

      <td>
        <span>{{ user?.failure }}</span>
      </td>

      <td>
        <span>{{ user?.no_td }}</span>
      </td>

      <td>
        <span>{{ user?.no_material }}</span>
      </td>
      <td>
        <span>{{ user?.meeting }}</span>
      </td>
      <td>
        <span>{{ user?.helping_colleague }}</span>
      </td>
      <td>
        <span>{{ user?.other }}</span>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">Nema pronađenih prodataka.</td>
    </tr>
  </ng-template>
</p-table>

<div class="mt-4">
  <p-table
    #dt1
    [value]="summary"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    class="mt-4"
    *ngIf="summary.length != 0"
  >
    <ng-template pTemplate="header" let-item>
      <tr>
        <th style="padding: 0.5rem">
          <span></span>
        </th>

        <th style="padding: 0.5rem">1 - Pauza/Ručak (min)</th>
        <th style="padding: 0.5rem">2 - Pomoć - Prijem robe (min)</th>
        <th style="padding: 0.5rem">3 - Pomoć - Utovar robe (min)</th>
        <th style="padding: 0.5rem">4 - Kvar - Mašina (Alat) (min)</th>
        <th style="padding: 0.5rem">5 - Nedostatak - Materijal (min)</th>
        <th style="padding: 0.5rem">6 - Nedostatak - TD (min)</th>
        <th style="padding: 0.5rem">7 - Sastanak (min)</th>
        <th style="padding: 0.5rem">8 - Obuka radnika (min)</th>
        <th style="padding: 0.5rem">9 - Ostalo (min)</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <span>Ukupno zastoj (min)</span>
        </td>

        <td>
          <span>{{ item?.lunch_break }}</span>
        </td>

        <td>
          <span>{{ item?.help_delivery_package }}</span>
        </td>

        <td>
          <span>{{ item?.help_reciving_package }}</span>
        </td>

        <td>
          <span>{{ item?.failure }}</span>
        </td>

        <td>
          <span>{{ item?.no_td }}</span>
        </td>

        <td>
          <span>{{ item?.no_material }}</span>
        </td>
        <td>
          <span>{{ item?.meeting }}</span>
        </td> <td>
          <span>{{ item?.helping_colleague }}</span>
        </td>
        <td>
          <span>{{ item?.other }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
